// https://vitejs.dev/config/#build-polyfillmodulepreload
import "vite/modulepreload-polyfill";

// Styles
import "./styles/main.scss";

let scroller = document.querySelector(".scroller");
scroller?.addEventListener("click", function () {
  window.scrollTo({
    top: window.innerHeight,
    behavior: "smooth",
  });
});

// Vue
import { createApp } from "vue";

// If you are build a SPA with a single <div id="app"></div> entry you would:
// import App from './App.vue'
// createApp(App).mount('#app')

// The example here is to have multiple Vue apps sprinkled throughout your page
// So we would instantiate any known components by their own

// First let's load all components that should be available to in-browser template compilation

// Example of how to import **all** components
// https://dev.to/jakedohm_34/auto-registering-all-your-components-in-vue-3-with-vite-4884

const modules = import.meta.globEager("./components/*.vue");
const components = {};
for (const path in modules) {
  const name = path
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");

  components[name] = modules[path].default;
}

import agegateComponent from "./components/agegate-component.vue";

const appage = createApp({
  components: {
    "agegate-component": agegateComponent,
  },
});
appage.mount("#app-agegate");

const app = createApp({
  components: {
    ...components,
  },
});
app.mount("#app");
